import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppStore } from '../../../store/useAppStore';
import { getRouteForTool, type ToolId } from '../../layout/workspace-config';

interface DashboardNavigationOptions {
    search?: string;
}

export function useDashboardNavigation(): (toolId: ToolId, options?: DashboardNavigationOptions) => void {
    const navigate = useNavigate();
    const setActiveTab = useAppStore(state => state.metaActions.setActiveTab);

    return useCallback((toolId: ToolId, options?: DashboardNavigationOptions) => {
        setActiveTab(toolId);
        const search = options?.search ?? '';
        void navigate(`${getRouteForTool(toolId)}${search}`);
    }, [navigate, setActiveTab]);
}
